import React from 'react';
import { Container, Typography, Grid, Paper, Avatar } from '@mui/material';

const testimonials = [
  {
    name: 'John Doe',
    feedback: 'This AI software revolutionized our pig farming operations!',
    avatar: '/images/john-doe.jpg',
  },
  {
    name: 'Jane Smith',
    feedback: 'Incredibly accurate and easy to use. Highly recommend!',
    avatar: '/images/jane-smith.jpg',
  },
  // Add more testimonials as needed
];

const Testimonials = () => {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        What Our Users Say
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {testimonials.map((testimonial, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper elevation={3} sx={{ p: 3, textAlign: 'center' }}>
              <Avatar
                src={testimonial.avatar}
                alt={testimonial.name}
                sx={{ width: 56, height: 56, margin: '0 auto 16px' }}
              />
              <Typography variant="h6">{testimonial.name}</Typography>
              <Typography variant="body1">{testimonial.feedback}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Testimonials;